<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <Header />
          <v-card class="mx-4 py-1 mt-9 mb-n5 theme" style="z-index: 1">
            <v-card-title primary-title>
              <v-spacer></v-spacer>
              <div class="white--text display-1 font-weight-light">
                Reset password
              </div>
              <v-spacer></v-spacer>
            </v-card-title>
          </v-card>
          <v-card class="elevation-0">
            <v-card-text>
              <div class="my-3">
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToRegister"
                  >Register
                </v-btn>
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToLogin"
                  style="float: right"
                  >login
                </v-btn>
                <div style="clear: both"></div>
              </div>
              <v-alert :value="alertShow" :type="alertType">{{
                alertText
              }}</v-alert>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="email"
                  label="Email"
                  type="email"
                  class="px-3"
                  placeholder="Registered Email"
                  hint="Please provide your registered email"
                  persistent-hint
                  :autofocus="true"
                  autocomplete="email"
                  tabindex="1"
                  :rules="[validationRules.email, validationRules.required]"
                ></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                class="action white--text rounded-sm mr-2"
                small
                depressed
                tabindex="2"
                @click="sendResetEmail"
                >Reset Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import { Actions } from "@/views/actions";
import { Component } from "@/views/component";

export default {
  name: Component.Auth.ResetPassword,
  components: { Header },
  data: () => {
    return {
      alertShow: false,
      alertType: "warning",
      alertText: "",
      valid: true,
      email: "",
    };
  },
  methods: {
    redirectToRegister() {
      this.$router.push({ name: Component.Auth.Register });
    },
    redirectToLogin() {
      this.$router.replace("/");
    },
    sendResetEmail() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(Actions.Auth.ResetPassword, this.email)
          .then(() => {
            this.alertShow = true;
            this.alertText = "Please check you email for further instructions";
            this.alertType = "success";
            setTimeout(() => this.$router.replace("/"), 2000);
          })
          .catch((e) => {
            console.error(e);
            this.alertShow = true;
            this.alertText =
              e.code === "auth/user-not-found"
                ? "You do not have account with us. Please register"
                : e.message;
            this.alertType = "warning";
          });
      }
    },
  },
  created() {
 
  },
};
</script>

<style  scoped>
.container {
  /*background: radial-gradient(#c4a0eb, #542aff) no-repeat;*/
  background: radial-gradient(#9c1a5f, #551738) no-repeat;
  place-items: center center;
}

div.v-alert {
  border-radius: 5px;
}

.v-input {
  font-weight: 300;
}
</style>
